export default function Band() {
  return (
    <section className="t-band" aria-labelledby="band-title">
      {/* The photograph is deliberately defocused and used as a ground for the
          copy: at this blur the sheet's own print reads as subject matter
          rather than as something to be read. The asset stays sharp on disk so
          the treatment can be re-tuned without regenerating it.
          Generated locally with Qwen-Image (Apache-2.0) — no third-party
          licence, so no entry in the footer credits. */}
      <div className="t-band__bg" aria-hidden="true">
        <img src="/close-package.jpg" alt="" width={2880} height={1040} decoding="async" />
      </div>

      <div className="t-wrap t-band__copy">
        <div className="t-block-head">
          <h2 id="band-title" className="t-h2 t-rise">
            From the close package to the pipeline.
          </h2>
          <p className="t-body t-para t-rise">
            Month-end close, reconciliation and reporting — built as systems that keep the numbers
            straight, rather than spreadsheets someone has to hold together by hand.
          </p>
        </div>
      </div>
    </section>
  );
}
